export const SOUNDS = 'SOUNDS';
export const SEQUENCES = 'SEQUENCES';
export const PRESETS = 'PRESETS';
export const INSTRUMENTS = 'INSTRUMENTS';
export const NOTES = 'NOTES';
export const EXTERNAL = 'EXTERNAL';
export const PACKS = 'PACKS';

